import { render, staticRenderFns } from "./goodsTypeModules.vue?vue&type=template&id=f72438a0&"
import script from "./goodsTypeModules.vue?vue&type=script&lang=js&"
export * from "./goodsTypeModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports